<router-outlet></router-outlet>
<p-toast></p-toast>
<p-confirmdialog #cd (keydown.enter)="cd.onAccept()" />

<!--

<p-toast [position]="'top-center'" [life]="3000"></p-toast>
<p-toast [position]="'top-left'" [life]="5000"></p-toast>
<p-toast [position]="'top-right'" [life]="2000"></p-toast>
<p-toast [position]="'bottom-center'" [life]="3000"></p-toast>
<p-toast [position]="'bottom-left'" [life]="6000"></p-toast>
<p-toast [position]="'bottom-right'" [life]="6000"></p-toast>

-->